export default __webpack_public_path__ + "static/media/before-footer-img6.1b77dbbc.png";